import styled from "styled-components";
import ProjectItem from "./ProjectItem";
import FixaKorkortIcon from "./../assets/images/fixa-korkort-icon.png";
import FixaKorkortImage from "./../assets/images/fixa-korkort-app.png";
import BadtempenIcon from "./../assets/images/badtempen-icon.png";
import BadtempenImage from "./../assets/images/badtempen-app.png";
import ThermometerIcon from "./../assets/images/thermometer-icon.png";
import ThermometerImage from "./../assets/images/thermometer-app.png";
import SolaSakertIcon from "./../assets/images/sola-sakert-icon.png";
import SolaSakertImage from "./../assets/images/sola-sakert-app.png";
import { colors, fonts, mobileMaxWidth, spacing } from "../theme";
import AnimatedSection from "./AnimatedSection";

const Section = styled.section`
  position: relative;
  z-index: 1;
  background: ${colors.background};
  padding: ${spacing.sectionY} ${spacing.sectionX};

  @media screen and (max-width: ${mobileMaxWidth}) {
    padding: ${spacing.sectionYMobile} 16px;
  }
`;

const Inner = styled.div`
  max-width: ${spacing.maxWidth};
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  max-width: 640px;
  margin: 0 auto 64px;
  text-align: center;
`;

const Eyebrow = styled.p`
  margin: 0;
  color: ${colors.accent};
  font-family: ${fonts.body};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Title = styled.h2`
  margin: 12px 0 0;
  font-family: ${fonts.heading};
  font-size: clamp(34px, 5vw, 52px);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: ${colors.ink};
`;

const Subtitle = styled.p`
  margin: 16px 0 0;
  color: ${colors.textSecondary};
  font-family: ${fonts.body};
  font-size: 18px;
  line-height: 1.6;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const OurProjectsElement = () => {
  return (
    <Section id="ourProjects">
      <Inner>
        <AnimatedSection>
          <SectionHeader>
            <Eyebrow>Portfolio</Eyebrow>
            <Title>Våra appar</Title>
            <Subtitle>
              Byggda från grunden och publicerade på App Store och Google Play.
            </Subtitle>
          </SectionHeader>
        </AnimatedSection>
        <List>
          <AnimatedSection>
            <ProjectItem
              mirrorImage={false}
              tint="#3b6cf6"
              appImage={FixaKorkortImage}
              appIcon={FixaKorkortIcon}
              title="Fixa Körkort"
              body="Fixa körkort hjälper personer som vill öva på teorin inför teoriprovet för B-körkort. Appen innehåller massvis av funktioner för att hjälpa användarna att klara teoriprovet."
              checkboxTexts={[
                "Över 870st körkortsfrågor",
                "Hjälpt massor av svenskar att ta körkort",
                "Över 100.000 nedladdningar",
              ]}
              googlePlayLink="https://play.google.com/store/apps/details?hl=sv&id=com.korkort"
              appStoreLink="https://apps.apple.com/SE/app/id1455678857"
              externalWebsite="https://fixakorkort.se"
            />
          </AnimatedSection>

          <AnimatedSection>
            <ProjectItem
              mirrorImage={true}
              tint="#219EBC"
              appImage={BadtempenImage}
              appIcon={BadtempenIcon}
              title="Badtempen"
              body="Badtempen gör det supersmidigt att dagligen få vattentemperaturer hos din närmsta badplats. Appen visar nämligen vattentemperaturer året om för alla badplatser längs med den svenska kusten."
              checkboxTexts={[
                "+550 stycken badplatser",
                "Temperaturer uppdateras var tredje timme",
                "Allmän information om badplatserna",
              ]}
              googlePlayLink="https://play.google.com/store/apps/details?id=se.badtempen.badtempen"
              appStoreLink="https://apps.apple.com/se/app/badtempen/id1468679946"
            />
          </AnimatedSection>

          <AnimatedSection>
            <ProjectItem
              mirrorImage={false}
              tint="#f97316"
              appImage={ThermometerImage}
              appIcon={ThermometerIcon}
              title="Termometer: Live Väder"
              body="En stilren och intuitiv mobilapp designad för att ge dig realtidsinformation om den aktuella temperaturen utomhus 24/7."
              checkboxTexts={[
                "Utomhustemperatur i realtid",
                "10-dagars prognos",
                "Tillgänglig på +70 olika språk",
              ]}
              googlePlayLink="https://play.google.com/store/apps/details?id=se.devkey.thermometer"
              appStoreLink="https://apps.apple.com/se/app/termometer-live-v%C3%A4der/id6473653209"
            />
          </AnimatedSection>

          <AnimatedSection>
            <ProjectItem
              mirrorImage={true}
              tint="#FCC231"
              appImage={SolaSakertImage}
              appIcon={SolaSakertIcon}
              title="Sola säkert"
              body="Hur länge kan du vara i solen innan huden riskerar att bränna sig? Sola säkert gör om dagens UV-prognos till en personlig tidsgräns utifrån din hudtyp och ditt solskydd."
              checkboxTexts={[
                "Personlig soltid för sex olika hudtyper",
                "Soltimer direkt på låsskärmen",
                "UV-prognos timme för timme",
              ]}
            />
          </AnimatedSection>
        </List>
      </Inner>
    </Section>
  );
};

export default OurProjectsElement;
